import React from 'react'

import { WizardStepRenderParams, useOnNext } from '@factorialco/deprecated-design-system'

import { type FormErrors } from 'modules/core/hooks/useForm'

import {
  CompetencyLevelsForm,
  type LevelData,
  validateLevels,
} from 'modules/competencies/components/CompetencyLevelsForm'
import { type WizardData } from 'modules/competencies/pages/CompetenciesList/NewCompetencyWizard/types'

type Props = WizardStepRenderParams<WizardData> & {
  errors: FormErrors<WizardData>
}

export const LevelsStep: React.FC<Props> = ({ data, onDataChanged, errors }) => {
  const [levelsAtValidation, setLevelsAtValidation] = React.useState<Array<string | number>>([])
  const [hasTriggeredValidation, setHasTriggeredValidation] = React.useState(false)

  const handleShowLevelError = (_field: keyof LevelData, level: LevelData) => {
    return hasTriggeredValidation && levelsAtValidation.includes(level.id)
  }

  const onLevelChange = (levels: LevelData[]) => onDataChanged({ ...data, levels })

  const onLevelAdd = (levels: LevelData[]) => {
    onDataChanged({ ...data, jobCatalogTreeNodeUuids: [], levels })
  }

  useOnNext(async () => {
    if (!hasTriggeredValidation) {
      setHasTriggeredValidation(true)
      setLevelsAtValidation(data.levels.map((level) => level.id))
    }

    const { hasError } = validateLevels(data.levels)

    if (hasError) {
      return Promise.reject()
    }
  })

  return (
    <CompetencyLevelsForm
      levels={data.levels}
      errors={errors.levels || {}}
      onShowError={handleShowLevelError}
      allowAdd
      allowDelete
      onLevelChange={onLevelChange}
      onLevelAdd={onLevelAdd}
      onLevelDelete={onLevelChange}
    />
  )
}
